import React from 'react';
import { Button, Typography } from '@mui/material';

export const SnackbarButton = ({ message }: { message: string }) => (
  <Button
    variant="contained"
    sx={{
      maxWidth: 30,
      maxHeight: 30,
      marginTop: 1,
      textTransform: 'none',
    }}
  >
    <Typography sx={{ fontSize: 12 }}>{message}</Typography>
  </Button>
);
